import Bugsnag from '@bugsnag/js';
import { Notify } from 'quasar';

export default class ErrorService {
  /**
   * Logs the given error to the console and notifies Bugsnag of the error (with option meta info).
   */
  static log(
    error: Error,
    meta: { [key: string]: string } = {},
    options: { severity?: 'error' | 'info' | 'warning' } = {}
  ) {
    console.error(error);
    Bugsnag.notify(error, (event) => {
      event.addMetadata('details', meta);
      if (options.severity) {
        event.severity = options.severity;
      }
    });
  }

  static notify({
    error,
    errorMeta = {},
    message,
  }: {
    error: Error;
    errorMeta?: { [key: string]: string };
    message: string;
  }) {
    if (error) {
      this.log(error, errorMeta);
    }

    const dismiss = Notify.create({
      color: 'negative',
      closeBtn: false,
      icon: 'warning',
      message,
      timeout: 0,
      actions: [
        {
          label: 'Dismiss',
          color: 'white',
          rounded: true,
          handler() {
            dismiss();
          },
        },
      ],
    });
  }
}
